export enum EARLY_SETTLEMENT_STATUS {
  NEW = 'NEW',
  IN_PROCESS = 'IN_PROCESS',
  APPROVED = 'APPROVED',
  VOID = 'VOID',
}
